import { useState, useLayoutEffect } from "react";
import { useDevice, useSchemadrawContainer } from "../components/board/App";
import { useUIAppState } from "../context/ui-appState";

export const useCreatePortalContainer = (opts?: {
  className?: string;
  parentSelector?: string;
}) => {
  const [div, setDiv] = useState<HTMLDivElement | null>(null);

  const device = useDevice();
  const { theme } = useUIAppState();

  const { container: schemadrawContainer } = useSchemadrawContainer();

  useLayoutEffect(() => {
    if (div) {
      div.className = "";
      div.classList.add("schemadraw", ...(opts?.className?.split(/\s+/) || []));
      div.classList.toggle("schemadraw--mobile", device.editor.isMobile);
      div.classList.toggle("theme--dark", theme === "dark");
    }
  }, [div, theme, device.editor.isMobile, opts?.className]);

  useLayoutEffect(() => {
    const container = opts?.parentSelector
      ? schemadrawContainer?.querySelector(opts.parentSelector)
      : document.body;

    if (!container) {
      return;
    }

    const div = document.createElement("div");

    container.appendChild(div);

    setDiv(div);

    return () => {
      container.removeChild(div);
    };
  }, [schemadrawContainer, opts?.parentSelector]);

  return div;
};
